import { Store } from 'src/store/index';

const getForwardUrl = (store: Store) => store.app.forwardUrl;

export default getForwardUrl;
